import { en } from '@/i18n/locales/en';
import { zhCN } from '@/i18n/locales/zh-CN';
import { LOCALE_STORAGE_KEY, type Locale, type Messages } from '@/i18n/types';

export const messagesByLocale: Record<Locale, Messages> = {
  'zh-CN': zhCN,
  en,
};

export function getMessages(locale: Locale): Messages {
  return messagesByLocale[locale];
}

export function detectDefaultLocale(): Locale {
  if (typeof navigator === 'undefined') {
    return 'zh-CN';
  }
  const lang = navigator.language.toLowerCase();
  if (lang.startsWith('zh')) {
    return 'zh-CN';
  }
  return 'en';
}

export function readStoredLocale(): Locale | null {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored === 'zh-CN' || stored === 'en') {
      return stored;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export type { Locale, Messages } from '@/i18n/types';
